/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'

import styled from 'styled-components'
import TrashIcon from './TrashIcon'
import Avatar from './Avatar'
import ProfileProperty from './ProfileProperty'
import { useSelector } from 'react-redux'
import MultiProfileConfirmPopUp from './MultiProfileConfirmPopUp'
import KidsPinPopup from './KidsPinPopUp'
import AvatarCollection from './AvatarCollection'
import { routeMap } from '../../route'
import { GlobalContext } from '../../context/global.context'
import useAuthApi from '../../apis/useAuthApi'
import { getLabelsObject } from './PinPopUpdata'
import { setUserAuthInfo } from '../../utils/localStorageService'
// import { createBrowserHistory } from 'history';
// import appMessages from './appMessages.json'
// import { avatarImage1 } from './MultiProgileImages'
// import { getLabelsObject } from './PinPopUpdata'
import Spinner from '../Spinner'
import useErrorUtils from '../../utils/useErrorUtils'


const ProfileDetails = () => {

    const history = useHistory()

    const [pageMode, setPageMode] = useState(null)
    const [name, setName] = useState('')
    const [isThisKidsProfile, setIsThisKidsProfile] = useState(false)
    const [isNeedPinToExitProfile, setIsNeedPinToExitProfile] = useState(false)
    const [isPushNotificationEnabled, setIsPushNotificationEnabled] = useState(false)
    const [theme, setTheme] = useState(null)
    const [avatarCollectionVisibility, setAvatarCollectionVisibility] = useState(false)
    const [isEnableSave, setEnableSave] = useState(false)
    const { dispatch, userInfo, userToken, showProfileDetails, selectedProfile } = useContext(GlobalContext)

    const [showConfirmPopUp, setShowConfirmPopUp] = useState(false)
    const { profileManagementThemes = {}, profileManagementConfig = {} } = useSelector(store => store.profileManagement)
    const [avatarsArray, setAvatarsArray] = useState(null)
    const [activeAvatar, setActiveAvatar] = useState(null)
    const { createProfileAPI, deleteProfileAPI, updateAccountAPI, updateProfileAPI, getAccountDetails } = useAuthApi()
    const { appConfig } = useSelector(store => store.appConfigReducers)
    const [baseUrl, updateBaseUrl] = useState(null)
    const [showKidsPinPopup, setShowKidsPinPopup] = useState(null)
    // const [profilePin, setProfilePin] = useState(null)
    const { appMessages = {} } = useSelector(store => store.appConfigReducers)
    const [isLoading, setIsLoading] = useState(false)
    const { showError } = useErrorUtils()
    const [showForgotFunction, setShowForgotFunction] = useState(null)

    const handleProfileNameChange = (e) => {
        const maxChars = profileManagementConfig.profileNameMaxChars
        const value = e.target.value
        if (maxChars >= value.length) setName(value)
    }

    useEffect(() => {
        const minChars = profileManagementConfig.profileNameMinChars
        const maxChars = profileManagementConfig.profileNameMaxChars
        const isEnable = minChars <= name.length && maxChars >= name.length
        setEnableSave(isEnable)
    }, [name])

    useEffect(() => {
        if (profileManagementConfig && profileManagementConfig.avatars) {
            let parsedData = JSON.parse(profileManagementConfig.avatars)
            setAvatarsArray(parsedData.avatars)
        }
    }, [profileManagementConfig])

    useEffect(() => {
        if (!appConfig.baseUrl) return
        updateBaseUrl(appConfig.baseUrl)
    }, [appConfig])

    useEffect(() => {
        if (pageMode === 'new') return
        if (avatarsArray) setActiveAvatar(avatarsArray[0])
    }, [avatarsArray, pageMode])

    // --Setting Profile Theme---
    useEffect(() => {
        if (profileManagementThemes) setTheme(profileManagementThemes)
    }, [profileManagementThemes])

    // --label variables --
    const [labelVariables, setLabelVariables] = useState({})
    const [popUpTexts, setPopUpTexts] = useState(null)
    const [popUpFunctions, setPopUpFunctions] = useState(null)

    useEffect(() => {
        if (showProfileDetails.profile === null) setPageMode('new')
        else setPageMode('edit')

    }, [])

    useEffect(() => {
        if (pageMode === 'new') {
            setAvatarCollectionVisibility(true)
            if (name) setName(null)
            // setActiveAvatar(null)
            if (isThisKidsProfile) setIsThisKidsProfile(null)
            if (isNeedPinToExitProfile) setIsNeedPinToExitProfile(null)
            if (isPushNotificationEnabled) setIsPushNotificationEnabled(null)
        }
        if (pageMode === 'edit') {
            showProfileDetails.profile && showProfileDetails.profile.name && setName(showProfileDetails.profile.name)
            showProfileDetails.profile && showProfileDetails.profile.avatar && setActiveAvatar(showProfileDetails.profile.avatar)
            showProfileDetails.profile && showProfileDetails.profile.type && setIsThisKidsProfile(showProfileDetails.profile.type === 'Kid' ? true : false)
            showProfileDetails.profile && showProfileDetails.profile.enablePushNotifications && setIsPushNotificationEnabled(showProfileDetails.profile.enablePushNotifications === 'true' ? true : false)
            showProfileDetails.profile && showProfileDetails.profile.requireExitPin && setIsNeedPinToExitProfile(showProfileDetails.profile.requireExitPin === 'true' ? true : false)
        }
    }, [pageMode])

    useEffect(() => {
        if (pageMode === 'new') setLabelVariables({
            "title": appMessages.label_profile_create_profile_create_profile,
            "input_title": appMessages.label_profile_create_profile_profile_name,
            "kids": "Kids",
            "property_one_title": appMessages.label_profile_create_profile_kids_profile,
            "property_one_description": appMessages.label_profile_create_profile_kids_profile_description,
            "property_two_title": appMessages.label_profile_create_profile_require_pin_profile_exit,
            "property_Two_description": appMessages.label_profile_create_profile_require_pin_profile_exit_description,
            "property_three_title": appMessages.label_profile_create_profile_push_notification,
            "property_Three_description": appMessages.label_profile_create_profile_push_notification_description,
            "negative_button_text": appMessages.label_profile_create_profile_button_cancel,
            "positive_button_text": appMessages.label_profile_create_profile_button_create_profile
        })
        else if (pageMode === 'edit') setLabelVariables({
            "title": appMessages.label_profile_edit_profile_edit_profile,
            "input_title": appMessages.label_profile_edit_profile_name,
            "kids": "Kids",
            "property_one_title": appMessages.label_profile_edit_profile_kids_profile,
            "property_one_description": appMessages.label_profile_edit_profile_kids_profile_description,
            "property_two_title": appMessages.label_profile_edit_profile_require_pin_profile_exit,
            "property_Two_description": appMessages.label_profile_edit_profile_require_pin_profile_exit_description,
            "property_three_title": appMessages.label_profile_edit_profile_push_notification,
            "property_Three_description": appMessages.label_profile_edit_profile_push_notification_description,
            "negative_button_text": appMessages.label_profile_edit_profile_button_cancel,
            "positive_button_text": appMessages.label_profile_edit_profile_button_save_changes
        })
    }, [appMessages, pageMode])

    //delete button click

    const handleDeleteProfileAPI = () => {
        setShowConfirmPopUp(false)
        setIsLoading(true)
        const urlParams = {
            userId: userInfo.userId,
            profileId: showProfileDetails.profile.profileId,
            token: userToken
        }

        deleteProfileAPI(baseUrl, {}, urlParams).then((res) => {



            // const toDelete = new Set([showProfileDetails.profile.profileId]);
            // const newArray = userInfo.profiles.filter(obj => !toDelete.has(obj.profileId));

            // userInfo.profiles = newArray
            // dispatch({ type: 'USER_INFO', value: userInfo })
            // setUserAuthInfo(userInfo)

            const headersParams = {
                userId: userInfo.userId,
                token: userToken
            }
            getAccountDetails(baseUrl, headersParams).then((res) => {
                let newUserInfo = { ...userInfo, ...res, token: headersParams.token }
                dispatch({ type: 'USER_INFO', value: newUserInfo })
                setUserAuthInfo(newUserInfo)
                dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })
                dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: true })
                setIsLoading(false)
                showError({ type: 'profileDeleted' })

            }).catch(() => {
                showError({ type: 'errorDeletingProfile' })
                setIsLoading(false)

            })




            // -----------------------------------------------

        }).catch((e) => {
            showError({ type: 'errorDeletingProfile' })
            setIsLoading(false)
        }
        )
    }

    const handleDeleteButtonClick = () => {
        setPopUpTexts({
            "title": appMessages.label_profile_edit_profile_delete_popup_title,
            "description": appMessages.label_profile_edit_profile_delete_popup_description,
            "positiveButtonText": appMessages.label_profile_edit_profile_delete_popup_button_cancel,
            "negativeButtonText": appMessages.label_profile_edit_profile_delete_popup_button_confirm
        })
        setPopUpFunctions({
            "positiveButtonFunction": () => setShowConfirmPopUp(false),
            "negativeButtonFunction": () => handleDeleteProfileAPI()
        })
        setShowConfirmPopUp(true)
    }

    const [popUpStatus, setPopUpStatus] = useState(null)
    //toggle kids profile
    //---------------------------------------------------------------------------------------------------
    const changeisKidsPinRequiredStatus = () => {
        if (!isNeedPinToExitProfile) { //OFF -> ON
            if (userInfo.profilePin !== 'null') {
                //already pin is set
                setIsNeedPinToExitProfile(true)
            }
            else {
                //show setupflow & set pin here  locally
                if (showForgotFunction) setShowForgotFunction(null)
                setPopUpTexts(getLabelsObject('create-kids-pin', appMessages))
                setShowKidsPinPopup(true)
                setPopUpStatus('create-kids-pin')
            }
        }
        else { //ON -> OFF
            //verify flow.
            // if (pageMode === 'new') {
            //     setIsNeedPinToExitProfile(false)
            // } else {
            //     if (!showForgotFunction) setShowForgotFunction(true)
            //     setPopUpTexts(getLabelsObject('verify-kids-pin-for-exit', appMessages))
            //     setShowKidsPinPopup(true)
            //     setPopUpStatus('verify-kids-pin-for-exit')
            // }
            setIsNeedPinToExitProfile(false)
        }
    }


    const [wrongPinCount, setWrongPinCount] = useState(0)





    //-------------------------------------------------------------------

    const [tempPINStrorage, setTempPINStrorage] = useState(null)
    const handlePinPopupReturn = (returnedPIN) => {




        setShowKidsPinPopup(false)
        if (popUpStatus === 'create-kids-pin') {
            if (showForgotFunction) setShowForgotFunction(null)
            setTempPINStrorage(returnedPIN)
            setPopUpTexts(getLabelsObject('create-kids-pin-confirm', appMessages))
            setShowKidsPinPopup(true)
            setPopUpStatus('create-kids-pin-confirm')
        }
        if (popUpStatus === 'create-kids-pin-confirm') {

            if (tempPINStrorage === returnedPIN) {
                //Set PIN API
                const headersParams = {
                    userId: userInfo.userId,
                    token: userToken
                }
                setIsLoading(true)
                updateAccountAPI(baseUrl, { profilePin: tempPINStrorage }, headersParams)
                    .then(() => {
                        setIsNeedPinToExitProfile(true)
                        dispatch({ type: 'USER_INFO', value: { ...userInfo, profilePin: tempPINStrorage } })
                        setUserAuthInfo({ ...userInfo, profilePin: tempPINStrorage })
                        setIsLoading(false)
                    })
                    .catch(() => {
                        showError({ type: 'errorUpdatingProfile' })
                        setIsLoading(false)
                    })
            } else {
                showError({ type: 'pinNotMatching' })
                setPopUpTexts(getLabelsObject('create-kids-pin-confirm', appMessages))
                setShowKidsPinPopup(true)
                setPopUpStatus('create-kids-pin-confirm')
            }

        }
        if (popUpStatus === 'verify-kids-pin-for-exit') { //just verifying the pin 
            if (returnedPIN !== userInfo.profilePin) {
                if (wrongPinCount < 4) {
                    //show just verify
                    setPopUpTexts(getLabelsObject('verify-kids-pin-for-exit', appMessages))
                    setShowKidsPinPopup(true)
                    setPopUpStatus('verify-kids-pin-for-exit')
                    setWrongPinCount(wrongPinCount + 1)

                }
                else {
                    //show want to reset
                    setPopUpTexts(getLabelsObject('do-you-want-pin-reset', appMessages))
                    setPopUpFunctions({
                        "positiveButtonFunction": () => {
                            setShowConfirmPopUp(false)
                        },
                        "negativeButtonFunction": () => {
                            //save flag to local storage and initiate logout.
                            dispatch({ type: 'USER_INFO', value: {} })
                            dispatch({ type: 'UNAUTHENTICATED' })
                            history.push(routeMap.login)
                            window.store.localStorage.clear()
                            window.store.localStoragetorage.setItem('RESET_PIN', selectedProfile.profileId)
                            dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": false, "profile": null } })
                        }
                    })
                    setShowConfirmPopUp(true)
                    // setPopUpStatus('do-you-want-pin-reset')
                    //show do you want rest popup 
                    setWrongPinCount(0)
                }
            } else {
                //toggle field
                setIsNeedPinToExitProfile(false)
                setWrongPinCount(0)

            }
        }

    }



    //main save function
    const saveChanges = () => {
        const hideListOnCancel = showProfileDetails.hideListOnCancel
        setIsLoading(true)
        if (pageMode === 'new') {
            const headerParams = {
                userId: userInfo.userId,
                token: userToken
            }
            const body = {
                name: name,
                type: isThisKidsProfile ? 'Kid' : 'Adult',
                avatar: activeAvatar,
                enablePushNotifications: isPushNotificationEnabled ? 'true' : 'false',
                requireExitPin: isNeedPinToExitProfile ? 'true' : 'false'
            }
            createProfileAPI(baseUrl, body, headerParams).then(() => {
                // const oldProfilesArray = userInfo.profiles
                // oldProfilesArray.push({
                //     profileId: res.profileId,
                //     name: res.name,
                //     type: res.type,
                //     avatar: res.avatar
                // })
                // userInfo.profiles = oldProfilesArray //old with new profile added
                // dispatch({ type: 'USER_INFO', value: userInfo })
                // dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })
                // dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: true })


                const headersParams = {
                    userId: userInfo.userId,
                    token: userToken
                }
                getAccountDetails(baseUrl, headersParams).then((res) => {
                    if (showProfileDetails && showProfileDetails.profile && selectedProfile && selectedProfile.profileId && showProfileDetails.profile.profileId === selectedProfile.profileId) dispatch({ type: 'SELECTED_PROFILE', value: body })
                    let newUserInfo = { ...userInfo, ...res }
                    dispatch({ type: 'USER_INFO', value: newUserInfo })
                    setUserAuthInfo(newUserInfo)
                    // setUserAuthInfo({ token: userToken}, { merge: true})

                    dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })
                    dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: true })
                    setIsLoading(false)
                    showError({ type: 'newProfileCreated' })

                })




            }).catch((e) => {
                setIsLoading(false)
                showError({ type: 'errorCreatingProfile' })
            })
        } else if (pageMode === 'edit') {
            const params = {
                profileId: showProfileDetails && showProfileDetails.profile && showProfileDetails.profile.profileId,
                userId: userInfo && userInfo.userId,
                token: userToken
            }

            const body = {
                profileId: showProfileDetails && showProfileDetails.profile && showProfileDetails.profile.profileId,
                name: name,
                avatar: activeAvatar,
                type: isThisKidsProfile ? 'Kid' : 'Adult',
                enablePushNotifications: isPushNotificationEnabled ? 'true' : 'false',
                requireExitPin: isNeedPinToExitProfile ? 'true' : 'false'
            }

            updateProfileAPI(baseUrl, body, params).then((res) => {
                // let currentProfileArray = userInfo.profiles
                // const toDelete = new Set([showProfileDetails.profile.profileId]);
                // const newArray = userInfo.profiles.filter(obj => !toDelete.has(obj.profileId));
                // newArray.push(res)
                // userInfo.profiles = newArray

                const headersParams = {
                    userId: userInfo.userId,
                    token: userToken
                }
                getAccountDetails(baseUrl, headersParams).then((res) => {
                    if (showProfileDetails && showProfileDetails.profile && selectedProfile && selectedProfile.profileId && showProfileDetails.profile.profileId === selectedProfile.profileId) dispatch({ type: 'SELECTED_PROFILE', value: body })
                    let newUserInfo = { ...userInfo, ...res }
                    dispatch({ type: 'USER_INFO', value: newUserInfo })
                    setUserAuthInfo(newUserInfo)
                    // setUserAuthInfo({ token: userToken}, { merge: true})

                    dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })
                    dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: !hideListOnCancel })
                    setIsLoading(false)
                    showError({ type: 'profileUpdated' })
                })
            }).catch((e) => {
                setIsLoading(false)
                showError({ type: 'errorUpdatingProfile' })
            })
        }
    }
    //---TO BE DELETD

    const handleForgotPinFunction = () => {
        //show want to reset
        setPopUpTexts(getLabelsObject('forgot-pin-login-confirmation', appMessages))
        setPopUpFunctions({
            "positiveButtonFunction": () => {
                setShowConfirmPopUp(false)
            },
            "negativeButtonFunction": () => {
                //save flag to local storage and initiate logout.
                dispatch({ type: 'USER_INFO', value: {} })
                dispatch({ type: 'UNAUTHENTICATED' })
                history.push(routeMap.login)
                window.store.localStorage.clear()
                window.store.localStorage.setItem('RESET_PIN', 'This Flag exist because the user triggered a reset password on next login')
                dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: { "flag": false, "profile": null } })
            }
        })
        setShowKidsPinPopup(false)
        setShowConfirmPopUp(true)
    }


    // ------------------

    const handleAvatarClick = (e) => {
        setActiveAvatar(e)
        setAvatarCollectionVisibility(false)

    }

    const openAvatarCollectionPopup = () => {
        setAvatarCollectionVisibility(true)
    }

    const cancelButtonFunction = () => {
        const hideListOnCancel = showProfileDetails.hideListOnCancel
        dispatch({ type: 'SET_SHOW_MULTI_PROFILE_LIST', value: !hideListOnCancel })
        dispatch({ type: 'SET_SHOW_PROFILE_DETAILS', value: false })
    }

    const [adultProfileArray, setAdultProfileArray] = useState([])
    useEffect(() => {
        const arr = userInfo.profiles.filter((profile) => profile.type === 'Adult')
        setAdultProfileArray(arr)
    }, [userInfo])

    return (
        <ProfileDetailsStyled theme={theme}>
            <div className="profile-details-wrapper app-wrapper">
                <div className="profile-details-main">
                    <div className="profile-details__header">
                        <div className="profile-details__header__title" onClick={() => history.push(routeMap.contactUs)}>{labelVariables.title}</div>
                        {(adultProfileArray && adultProfileArray.length === 1 && pageMode === 'edit' && showProfileDetails && showProfileDetails.profile && showProfileDetails.profile.type && showProfileDetails.profile.type === 'Adult') || (selectedProfile && selectedProfile.type === 'Kid') || pageMode === 'new' || (showProfileDetails && showProfileDetails.profile && showProfileDetails.profile.profileId && selectedProfile && showProfileDetails.profile.profileId === selectedProfile.profileId) ? <></> : <div className="profile-details__header__delete-icon" ><TrashIcon onClick={() => handleDeleteButtonClick()}
                            color={theme && theme.themeProfileDetails && theme.themeProfileDetails.header && theme.themeProfileDetails.header.accent && theme.themeProfileDetails.header.accent.primary} height='18px' />
                        </div>}
                    </div>
                    <div className="profile-details__avatar"><Avatar editFunction={openAvatarCollectionPopup} height='90px' image={activeAvatar} status='edit' showBorder={true} /></div>
                    {isThisKidsProfile && <div className="profile-details__kids-label">{labelVariables.kids}</div>}
                    <div className="profile-details__title">{labelVariables.input_title}</div>
                    <div className="profile-details__input"><input value={name} onChange={handleProfileNameChange} /></div>
                    <div className="profile-details__properties">
                        {(adultProfileArray && adultProfileArray.length === 1 && pageMode === 'edit' && showProfileDetails.profile.type === 'Adult') || (selectedProfile && selectedProfile.type === 'Kid') ? <></> : <div className="profile-details__properties__lides-profile"><ProfileProperty title={labelVariables.property_one_title} description={labelVariables.property_one_description} status={isThisKidsProfile} onToggle={() => setIsThisKidsProfile(!isThisKidsProfile)} /></div>}
                        {isThisKidsProfile && <div className="profile-details__properties__exit_pin"><ProfileProperty title={labelVariables.property_two_title} description={labelVariables.property_Two_description} status={isNeedPinToExitProfile} onToggle={() => changeisKidsPinRequiredStatus()} /></div>}
                        <div className="profile-details__properties__push-notification"><ProfileProperty title={labelVariables.property_three_title} description={labelVariables.property_Three_description} status={isPushNotificationEnabled} onToggle={() => setIsPushNotificationEnabled(!isPushNotificationEnabled)} /></div>
                    </div>
                    <div className="profile-details__buttons">
                        <div className="profile-details__buttons_negative" onClick={() => cancelButtonFunction()} >{labelVariables.negative_button_text}</div>
                        <div className={isEnableSave ? 'profile-details__buttons_positive' : 'profile-details__buttons_positive disabled'} onClick={isEnableSave ? () => saveChanges() : null} >{labelVariables.positive_button_text}</div>
                    </div>
                </div>
            </div>
            {showConfirmPopUp && <MultiProfileConfirmPopUp text={popUpTexts} functions={popUpFunctions} />}
            {showKidsPinPopup && <KidsPinPopup labels={popUpTexts} successFunction={handlePinPopupReturn} cancelFunction={() => setShowKidsPinPopup(false)} forgotFunction={showForgotFunction ? () => handleForgotPinFunction() : null} />}
            {avatarCollectionVisibility &&
                <AvatarCollection
                    avatarsArray={avatarsArray}
                    activeAvatar={activeAvatar}
                    selectFunction={(e) => handleAvatarClick(e)}
                    closeFunction={() => setAvatarCollectionVisibility(false)}
                    preventClose={!activeAvatar}
                />}
            {isLoading && <Spinner isLoading={true} size={60} />}
        </ProfileDetailsStyled>
    )
}

const ProfileDetailsStyled = styled.div`
.disabled{
    opacity: 0.5;
}

.profile-details-wrapper{
    z-index: 5;
    background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.body && themeProfileDetails.body.background && themeProfileDetails.body.background.primary};

    .profile-details-main{
        .profile-details__header{
            display: flex;
            flex-direction: row;
            align-content: center;
            .profile-details__header__title{
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.body && themeProfileDetails.body.background && themeProfileDetails.body.text.primary};
            }
            .profile-details__header__delete-icon{
                margin-left: auto;
                cursor: pointer;
            }
            
        }//profile-details__header

        .profile-details__avatar{
            margin: 31px auto;
            margin-bottom: 0px;

            .avatar-wrapper{
                margin: 0 auto;
            }
        }

        .profile-details__kids-label{
            margin: 10px auto;
            font-size: 18px;
            color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.body && themeProfileDetails.body.background && themeProfileDetails.body.text.primary};
            font-weight: 300;
            text-align: center;
        }//profile-details__kids-label
        .profile-details__title{

                font-size: 16px;
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.body && themeProfileDetails.body.background && themeProfileDetails.body.text.primary};
                font-weight: 600;
                margin-right: auto;
                margin-top: 47px;
        }//profile-details__title

        .profile-details__input{
            margin: 0 auto;
            margin-top: 5px;
            input{
                width: 100%;
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.body && themeProfileDetails.body.background && themeProfileDetails.body.text.primary};
                font-size: 14px;
                padding: 20px 20px;
                background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.inputBox && themeProfileDetails.compositeStyle.inputBox.background && themeProfileDetails.compositeStyle.inputBox.background.primary};
                border-radius: 5px;
                border: none;
                outline: none;
            }
        }

        .profile-details__buttons{

            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            margin-top: 50px;
            margin-bottom: 100px;

            .profile-details__buttons_negative{
                border-radius: 5px;
                padding: 15px 0px;
                width: 200px;
                max-width: 40%;
                text-align: center;
                font-size: 16px;
                font-weight: 900;
                cursor: pointer;
                border: 1px solid ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.normal && themeProfileDetails.compositeStyle.secondaryButton.normal.stroke};
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.normal && themeProfileDetails.compositeStyle.secondaryButton.normal.text};
                background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.normal && themeProfileDetails.compositeStyle.secondaryButton.normal.background};
            
                :hover{
                    border: 1px solid ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.focussed && themeProfileDetails.compositeStyle.secondaryButton.focussed.stroke};
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.focussed && themeProfileDetails.compositeStyle.secondaryButton.focussed.text};
                background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.secondaryButton && themeProfileDetails.compositeStyle.secondaryButton.focussed && themeProfileDetails.compositeStyle.secondaryButton.focussed.background};
                }

            }//profile-details__buttons_negative

            .profile-details__buttons_positive{
                border-radius: 5px;
                padding: 15px 0px;
                width: 200px;
                max-width: 40%;
                text-align: center;
                font-size: 16px;
                font-weight: 900;
                cursor: pointer;
                border: 1px solid ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.normal && themeProfileDetails.compositeStyle.primaryButton.normal.stroke};
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.normal && themeProfileDetails.compositeStyle.primaryButton.normal.text};
                background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.normal && themeProfileDetails.compositeStyle.primaryButton.normal.background};
            
                :hover{
                    border: 1px solid ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.focussed && themeProfileDetails.compositeStyle.primaryButton.focussed.stroke};
                color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.focussed && themeProfileDetails.compositeStyle.primaryButton.focussed.text};
                background-color: ${({ theme: { themeProfileDetails } }) => themeProfileDetails && themeProfileDetails.compositeStyle && themeProfileDetails.compositeStyle.primaryButton && themeProfileDetails.compositeStyle.primaryButton.focussed && themeProfileDetails.compositeStyle.primaryButton.focussed.background};
                }
            }//profile-details__buttons_positive
        }

    }//profile-details-main

}//profile-details-wrapper


`

export default ProfileDetails